import React from "react";

class PowerIcon extends React.Component { 
    render() {
        return (
			<svg width="14" height="14" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M7 1V5.79953" stroke="#EAEAEA" strokeMiterlimit="10" strokeLinecap="round"/>
				<path d="M2.98851 2.20117C1.76689 3.33716 1 4.97804 1 6.80124C1 10.2232 3.68754 13.0001 6.99946 13.0001C10.3114 13.0001 12.9989 10.2232 12.9989 6.80124C12.9989 4.97103 12.2252 3.33015 11.0104 2.20117" stroke="#EAEAEA" strokeMiterlimit="10" strokeLinecap="round"/>
			</svg>


        )
    }
}

export default PowerIcon;




